import { BackwardButton } from '@geberit/gdds';

// styles
import styles from './image-gallery.module.scss';

// types
import type { ItemNordicsProps } from 'components/ContentElementsGdds/image-gallery/types';

// components
import { Image } from 'components/image/image';
import { InlineEdit } from 'components/ContentCreator/InlineEdit';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { decodingContent } from 'utils/decodingContent';
import { usePreviewIdBuilder } from 'utils/preview-id-builder';

export function GalleryItem({ item, setCurrentItem, index }: Readonly<ItemNordicsProps>) {
  const { pictureObject, pictureObjectMobile, pictureAlt, pictureCaption } = item;
  const isMobile = useIsMobile();
  const previewIdBuilder = usePreviewIdBuilder();

  const image = (isMobile && pictureObjectMobile) || pictureObject;
  const ratio =
    (isMobile && pictureObject?.aspectRatio?.replace('_', ':')) ||
    pictureObject?.aspectRatio?.replace('_', ':');

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      setCurrentItem({ index });
    }
  };

  return (
    <div className={styles.imageCol}>
      <InlineEdit previewId={`#${index}`}>
        <div
          className={styles.imageWrapper}
          onClick={() => setCurrentItem({ index })}
          onKeyUp={onKeyUp}
        >
          <Image
            data={image}
            alt={pictureAlt}
            title={pictureAlt}
            format={image?.format}
            aspectRatio={ratio}
          />
          {!isMobile && <BackwardButton stylingType="iconDark" symbol="zoom_in" isIcon />}
        </div>
        {pictureCaption && (
          <div
            data-preview-id={previewIdBuilder('#st_pictureCaption')}
            className={styles.pictureCaption}
          >
            {decodingContent(pictureCaption)}
          </div>
        )}
      </InlineEdit>
    </div>
  );
}
